import './index.scss';
import MapsEmbed from './components/MapsEmbed';

interface AppProps {
  hashcode: string;
  zoom: number;
  height: number;
}

function App(props: AppProps) {
  return (
    <div className="app">
      <MapsEmbed hashcode={ props.hashcode } zoom={ props.zoom } height={ props.height } />
    </div>
  );
}

export default App;
